import { createRouter } from '@tanstack/react-router';
import { getRoutePath } from '@/utils/getRoutePath';
import { routeTree } from '../routeTree.gen';

// The router base path is the public route prefix the reverse proxy serves the app under
// (e.g. /payments/make-payment) — NOT Vite's `base` (import.meta.env.BASE_URL), which is the
// absolute CDN URL used to prefix static asset references and would inject the CDN origin into
// every route. It is also distinct from where assets are served on the CDN
// (CARVANA_APP_PUBLIC_URL, .../selfservicepayments): the app is routed at CARVANA_APP_ROUTE_PATH.
export const router = createRouter({
  routeTree,
  basepath: getRoutePath(),
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
